'use strict';

import EventEmitter from './EventEmitter';

export default class BackendClient extends EventEmitter {
    constructor(options) {
        super();

        this.endpoint = undefined;
        this.token    = undefined;
        this.refresh  = undefined;

        this._parseOptions(options);

        this.socket      = null;
        this.connected   = false;
        this.connecting  = false;
        this.sendQueue   = [];

        this.refreshTimeout = 15 * 1000; // tokens are valid for 30 seconds only
        this.refreshAfter   = (new Date()).getTime() + this.refreshTimeout;

        this.on('open', () => {
            this._flushSendQueue();
        });

        this.on('message', payload => {
            if (payload.method === 'watch.event') {
                const serial = payload.data ? payload.data.serial : undefined;
                const topic  = payload.data ? payload.data.topic  : undefined;
                if (typeof topic === 'string' && typeof serial === 'string') {
                    this.emit(payload.method, serial, topic, payload.data);
                }
            }
        });
    }

    connect() {
        if (this.connected || this.connecting || !this.endpoint) {
            return;
        }

        const doConnect = () => {
            let url = this.endpoint;
            if (this.token) {
                url += '?token=' + encodeURIComponent(this.token);
            }

            this.connecting = true;
            this.socket     = new WebSocket(url);

            this.socket.onopen = event => {
                this.connected   = true;
                this.connecting  = false;

                this.emit('open', event);
            };
            this.socket.onclose = event => {
                this.connected = false;
                this.socket    = null;

                this.emit('close', event);
            };
            this.socket.onerror = event => {
                if (this.connecting) {
                    this._flushSendQueue(new Error('Connection failed'));
                    this.connecting = false;
                }
                this.socket.close();
                this.emit('error', event);
            };
            this.socket.onmessage = event => {
                try {
                    const payload = JSON.parse(event.data);
                    this.emit('message', payload);
                } catch (error) {
                    if (
                        typeof console === 'object'
                        && typeof console.error === 'function'
                    ) {
                        console.error(error);
                    }
                }
            };
        };

        if (
            typeof axios === 'function'
            && this.refresh
            && (new Date()).getTime() > this.refreshAfter
        ) {
            axios
            .get(this.refresh)
            .then(({ data }) => {
                this._parseOptions(data);
                doConnect();
            })
            .catch(error => this._flushSendQueue(error))
            .finally(() => {
                this.refreshAfter = (new Date()).getTime() + this.refreshTimeout;
            })
        } else {
            doConnect();
        }
    }

    send(data) {
        return new Promise((resolve, reject) => {
            const payload = JSON.stringify(data);
            if (this.connected) {
                try {
                    this.socket.send(payload);
                    resolve();
                } catch (error) {
                    reject(error);
                }
            } else {
                this.sendQueue.push([payload, resolve, reject]);
                this.connect();
            }
        });
    }

    _parseOptions(options) {
        this.endpoint = options ? options.endpoint : undefined;
        this.token    = options ? options.token    : undefined;
        this.refresh  = options ? options.refresh  : undefined;
    }

    _flushSendQueue(error) {
        if (!this.sendQueue.length) {
            return;
        }

        const queue = this.sendQueue;
        this.sendQueue = [];

        for (const [payload, resolve, reject] of queue) {
            if (error) {
                reject(error);
            } else {
                try {
                    this.socket.send(payload);
                    resolve();
                } catch (caught) {
                    reject(caught);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/BackendClient.js